import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import connect from "react-redux/es/connect/connect";
import ModalContentVideoPlayer from "../../../SHARED/components/modalcontentvideoplayer/modalcontentvideoplayer.component";

class ModalVideoPlayer extends React.Component {

    render() {
        return (
            <div>
                <Modal size={this.props.size} isOpen={this.props.openModal} toggle={this.props.toggle} className={this.props.className}>
                    <ModalBody>
                        <ModalContentVideoPlayer url={this.props.url}/>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(ModalVideoPlayer);


// WEBPACK FOOTER //
// ./src/FO/components/modalvideoplayer/modalvideoplayer.component.js